import React from 'react';
import './LegalPage.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-background" />
      
      <div className="container">
        <div className="legal-content">
          
          {/* Header */}
          <div className="legal-header">
            <div className="legal-badge">
              <div className="legal-badge-dot" />
              Legal Document
            </div>
            <h1 className="legal-title">Privacy Policy</h1>
            <p className="legal-subtitle">
              Last updated: December 1, 2024
            </p>
          </div>
          
          {/* Content */}
          <div className="legal-body">
            
            <section className="legal-section">
              <h2>1. Information We Collect</h2>
              <p>
                At Nuroveli, we collect information to provide better services to our users. 
                This includes personal information you provide directly, usage data, and information 
                collected through cookies and similar technologies.
              </p>
              
              <h3>1.1 Personal Information</h3>
              <ul>
                <li>Name and contact information</li>
                <li>Company and job title</li>
                <li>Email address and phone number</li>
                <li>Account credentials</li>
              </ul>
              
              <h3>1.2 Usage Data</h3>
              <ul>
                <li>Log data and access times</li>
                <li>Device and browser information</li>
                <li>IP address and location data</li>
                <li>Feature usage and preferences</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>2. How We Use Your Information</h2>
              <p>We use the collected information for the following purposes:</p>
              <ul>
                <li>Providing and maintaining our cybersecurity services</li>
                <li>Personalizing your experience</li>
                <li>Communicating with you about our services</li>
                <li>Improving our platform and developing new features</li>
                <li>Ensuring security and preventing fraud</li>
                <li>Complying with legal obligations</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>3. Information Sharing</h2>
              <p>
                We do not sell, trade, or otherwise transfer your personal information to third parties, 
                except in the following circumstances:
              </p>
              <ul>
                <li>With your explicit consent</li>
                <li>To comply with legal obligations</li>
                <li>To protect our rights and safety</li>
                <li>With trusted service providers under strict confidentiality agreements</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>4. Data Security</h2>
              <p>
                We implement industry-standard security measures to protect your information, including:
              </p>
              <ul>
                <li>Encryption of data in transit and at rest</li>
                <li>Regular security audits and assessments</li>
                <li>Access controls and authentication protocols</li>
                <li>Secure data centers and infrastructure</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>5. Your Rights</h2>
              <p>You have the following rights regarding your personal information:</p>
              <ul>
                <li>Access and review your personal data</li>
                <li>Request corrections or updates</li>
                <li>Request deletion of your data</li>
                <li>Object to or restrict processing</li>
                <li>Data portability</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>6. Cookies and Tracking</h2>
              <p>
                We use cookies and similar technologies to enhance your experience. 
                You can control cookie preferences through your browser settings.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>7. Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy, please contact us at:
              </p>
              <div className="legal-contact">
                <p><strong>Email:</strong> privacy@nuroveli.com</p>
                <p><strong>Phone:</strong> +1 (555) 123-4567</p>
                <p><strong>Address:</strong> 123 Cybersecurity Avenue, Silicon Valley, CA 94043</p>
              </div>
            </section>
            
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
